"use strict";

/**
 * Removes leading and trailing whitespace from `str`.
 *
 * @param {String} str The string to trim.
 * @returns {String} Returns the trimmed string.
 * @example
 *
 * trim('  abc  '); // => 'abc'
 *
 */
module.exports = function (str) {
  if (str === void 0) {
    str = '';
  }
  return str.toString().trim() || '';
};